import { Box, Chip, Typography } from "@material-ui/core";
import React from "react";
import OpenApiSpecIcon from "legacy-components/icons/OpenApiSpecIcon";

interface SpecViewerProps {
  specName?: string;
}

export const SpecViewer: React.FC<SpecViewerProps> = ({ specName }) => {
     return (
    <Box style={{ borderColor: "#0063A3", borderStyle: "solid", borderWidth: "2px", display: "flex", alignItems: "center", height: "91px", width: "550px" , justifyContent: "start", borderRadius: "8px" }}>
          <OpenApiSpecIcon style={{ width: "50px", height: "50px", marginLeft: '16px' }} />
      <Box style={{ minWidth: '120px', marginLeft: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <Typography variant="body1" style={{ fontSize: '14px', fontWeight: 500 }}>
            {specName}
        </Typography>
      </Box>
    </Box>
  );
};
